export const DATA_EXPLORER_FLAGS = {
  BASE: 'dataExplorer',
  ASK_AI: 'dataExplorerAskAi',
  MANAGE_DASHBOARDS: 'dataExplorerManageDashboards',
  AI_HIGHLIGHTS: 'dataExplorerAiHighlights',
  DASHBOARD_SHARING: 'dataExplorerDashboardSharing',
  /**
   * Opt back into the new inline-Events-View `EventCard`. The Events View
   * defaults to the legacy `Event` card; enabling this flag renders the newer
   * NDE card instead. See {@link EventCardGrid}.
   */
  NEW_EVENT_CARD: 'dataExplorerNewEventCard',
  /**
   * Access to the standalone Data Explorer VerifEye reviewer tab (SL-15900).
   * Independent of {@link DATA_EXPLORER_FLAGS.BASE} — a reviewer may hold only this.
   */
  VERIFEYE: 'dataExplorerVerifeye',
  /**
   * Permission to send a dashboard's events to VerifEye and assign reviewers
   * (SL-15900). Distinct from {@link DATA_EXPLORER_FLAGS.MANAGE_DASHBOARDS}.
   */
  MANAGE_VERIFEYE: 'dataExplorerManageVerifeye',
} as const;
